import { useContext, useState } from "react"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import { Button, CustomContainer, FlexRow, Form, FormGroup, FormGroupWithIcon, ScreenTitle } from "src/style"
import { FiChevronDown } from "react-icons/fi"
import { AppCenterPopupPlusD3, Portal, StatementConfirmationD3, TxPinVerificationD3 } from "src/component"
import helpers from "src/utils/helpers"

export const StatementToThirdPartyD3: React.FC<any> = ({close}) => {
    const {notifier} = useContext(VisibilityContext)
    const [input, setInput] = useState({sourceAccount: '', thirdParty: '', startDate: '', endDate: ''})
    const [view, setView] = useState('send-statement')

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})

    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        setView('statement-confirmation')
    }

    async function handleSubmit() {
        notifier.show('Statement Sent', null, 'success')
        close()
    }

    return (
        <Portal>
            { view === 'send-statement' &&
                <AppCenterPopupPlusD3
                    title='Send Statement to Embassy' 
                    height='52' overflow='hidden'
                    contentHeight='52' zIndex='6'
                    maxHeight='89'
                    close={close}
                >
                    <ScreenTitle 
                        textSize="2" fontWeight="600" 
                        color="#211121" bottomMargin="2.5"
                        className="module-row-title"
                    >
                        Send Statement to Embassy
                    </ScreenTitle>
                    <CustomContainer>
                    <Form onSubmit={handleProceed}>
                            <FormGroupWithIcon>
                                <label>Source Account</label>
                                <div className="input-with-icon">
                                    <select 
                                        placeholder="Source Account"
                                        name='sourceAccount'
                                        value={input.sourceAccount}
                                        style={{color: input.sourceAccount ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                        //required
                                    >
                                        <option value="">Select Source Account</option>
                                        <option value="2236728192">Qore - 2236728192</option>
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                            <FormGroupWithIcon>
                                <label>Third Party</label>
                                <div className="input-with-icon">
                                    <select 
                                        name='thirdParty'
                                        value={input.thirdParty}
                                        style={{color: input.thirdParty ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                        //required
                                    >
                                        <option value="">Select Third Party</option>
                                        <option value="Page Financials">Page Financials</option>
                                        <option value="Appzone">Appzone</option>
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                            <FormGroup>
                                <label>Start Date</label>
                                <input 
                                    placeholder='dd/mm/yyyy' 
                                    type='date'
                                    name='startDate'
                                    max={helpers.getInputValidDate()}
                                    style={{color: input.startDate ? '#000000' : '#667085'}}
                                    value={input.startDate}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup>
                            <FormGroup>
                                <label>End Date</label>
                                <input 
                                    placeholder='dd/mm/yyyy' 
                                    type='date'
                                    name='endDate'
                                    max={helpers.getInputValidDate()}
                                    style={{color: input.endDate ? '#000000' : '#667085'}}
                                    value={input.endDate}
                                    onChange={handleInput}
                                    autoComplete="off"
                                />
                            </FormGroup>
                            <FlexRow topMargin='2.5'>
                                <Button 
                                    width='100' sizeUnit="%" height='4.4' 
                                    borderColor='#0D968F' hoverBgColor='#fff' 
                                    hoverColor='#0D968F' titleSize='1.4'
                                >
                                    Proceed
                                </Button>
                            </FlexRow>
                        </Form>
                    </CustomContainer>
                </AppCenterPopupPlusD3>
            }
            { view === 'pin' &&
                <TxPinVerificationD3
                    close={close}
                    next={handleSubmit} 
                />
            }
            { view === 'statement-confirmation' &&
                <StatementConfirmationD3
                    close={close}
                    next={() => setView('pin')}
                    back={() => setView('send-statement')}
                    data={input}
                    type='thirdParty'
                />
            }
        </Portal>
    )
}